export default __webpack_public_path__ + "static/media/logo.16fec824.svg";